import { useField } from 'formik';
import { NumberWithVariableUnit } from '../NumberWithVariableUnit';
import { NumberWithUnit, UnitOption } from '../NumberWithVariableUnitTypes';

interface FormikNumberWithVariableUnitProps {
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  units: UnitOption[];
  min?: number;
  max?: number;
  step?: number;
  className?: string;
}

export const FormikNumberWithVariableUnit = ({
  name,
  label,
  placeholder,
  required,
  disabled,
  units,
  min,
  max,
  step,
  className,
}: FormikNumberWithVariableUnitProps) => {
  const [field, meta, helpers] = useField<NumberWithUnit>(name);

  const handleChange = (value: NumberWithUnit) => {
    helpers.setValue(value);
    helpers.setTouched(true);
  };

  const error = meta.touched && meta.error ? meta.error : undefined;

  return (
    <NumberWithVariableUnit
      label={label}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      value={field.value}
      onChange={handleChange}
      units={units}
      min={min}
      max={max}
      step={step}
      error={error}
      className={className}
    />
  );
};
